import { ExternalLink } from "lucide-react";
import { compact } from "./utils";

export const MarketCard = ({ m }) => {
  const top = m.outcomes.reduce((a, b) => (b.price > a.price ? b : a));
  return (
    <article className="rounded-lg border border-[#1A2338] bg-[#0F1A2E] p-4 hover:border-[#22D3EE]/60 transition-colors" data-testid={`market-card-${m.id}`}>
      <div className="flex gap-3 items-start">
        {m.image && <img src={m.image} alt="" className="w-9 h-9 rounded-md object-cover shrink-0" />}
        <h3 className="text-sm font-semibold leading-snug flex-1">{m.question}</h3>
        <a href={m.url} target="_blank" rel="noreferrer" className="text-slate-500 hover:text-[#22D3EE]" data-testid={`market-link-${m.id}`} aria-label="Open on Polymarket US">
          <ExternalLink className="w-4 h-4" />
        </a>
      </div>
      <div className="mt-3 space-y-2">
        {m.outcomes.slice(0, 4).map((o) => (
          <div key={o.name}>
            <div className="flex justify-between text-xs">
              <span className="text-slate-300 truncate pr-2">{o.name}</span>
              <span className="font-num font-semibold">{(o.price * 100).toFixed(1)}¢</span>
            </div>
            <div className="h-1.5 rounded-full bg-[#1A2338] mt-1 overflow-hidden">
              <div className={`h-full ${/^no$/i.test(o.name) ? "bg-[#F87171]" : "bg-[#22D3EE]"}`} style={{ width: `${o.price * 100}%` }} />
            </div>
          </div>
        ))}
      </div>
      <p className="text-[11px] text-slate-400 mt-3">
        Crowd thinks <span className="text-slate-200 font-semibold">"{top.name}"</span> has about a {Math.round(top.price * 100)}% chance.
      </p>
      <div className="flex justify-between text-[10px] font-num uppercase tracking-widest text-slate-500 mt-2">
        {m.volume24hr != null ? <span>24h vol {compact(m.volume24hr)}</span> : m.category && <span className="capitalize">{m.category}</span>}
        {m.end_date && <span>Ends {new Date(m.end_date).toLocaleDateString()}</span>}
      </div>
    </article>
  );
};
